<template>
  <ac-modal :title="'Reset Password'" :size-class="'modal-md'" ref="modalRef">
    <template>
      <form v-if="widgetReady">
        <div class="row">
          <div class="info-board info-board-blue" style="margin: 0 0 20px 0">            
            <input type="checkbox" class="form-control" id="sendReset" v-model="sendReset" @change="toggleSendReset"/>            
            <label for="sendReset">Send {{ vm.fullName }} a password reset email?</label>
          </div>
        </div>
      </form>
    </template>
    <template slot="buttons">
      <button class="btn btn-sm btn-red margin-gutters" @click="closeModal">
        CANCEL
      </button>
      <button class="btn btn-sm btn-green margin-gutters" :disabled="!sendReset" @click="resetPassword">
        SEND
      </button>
    </template>
  </ac-modal>
</template>



<script>
import { api } from "../../global/framework/api.js";
import { notifications } from "../../global/notifications";

export default {
  name: "PasswordResetModal",
  data() {
    return {
      vm: { fullName: String, consumerId: Number, email: String },
      sendReset: false,
      enableSend: false,
      widgetReady: false
    }
  },
  computed: {
    vmRef() {
      return this.$data;
    }
  },
  methods: {
    async showModal({ consumerId: consumerId, fullName: fullName, email: email }) {
      this.vm = { fullName, consumerId, email };      
      this.widgetReady = true;
      this.$refs.modalRef.open();
    },
    closeModal() {
      this.$refs.modalRef.close();
    },
    toggleSendReset(){
      console.log("toggle send", {sendReset: this.sendReset})
      this.enableSend = this.sendReset;
    },
    async resetPassword() {
      if (this.sendReset) {
        await api.post('Account', 'ForgotPassword', { email: this.vm.email });
        this.closeModal();
      }
    }
  }


}
</script>

<style scoped>
.select-checkbox {
    float:left;
    position: unset;
    visibility: visible;
    height: 15px;
    width: 15px;
    margin: 0px 0px 5px;
}
</style>